export const KLINE_HIGH_FETCH = "kline_high_fetch";
export const KLINE_HIGH_FETCH_SUCCESSFUL = "kline_high_fetch_successfull";
export const KLINE_HIGH_FETCH_FAILED = "kline_high_fetch_failed";

export const OHLCV_FETCH = "OHLCV_FETCH";
export const OHLCV_FETCH_SUCCESSFUL = "OHLCV_FETCH_SUCCESSFUL";
export const OHLCV_FETCH_FAILED = "OHLCV_FETCH_FAILED";